import { render } from "./QuestionnaireSetting.vue?vue&type=template&id=e76645a6&scoped=true"
import script from "./QuestionnaireSetting.vue?vue&type=script&lang=js"
export * from "./QuestionnaireSetting.vue?vue&type=script&lang=js"

import "./QuestionnaireSetting.vue?vue&type=style&index=0&id=e76645a6&scoped=true&lang=css"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e76645a6"]])

export default __exports__